import IconButtonComponent from './IconButton.component';

export * from './IconButton.component';
export default IconButtonComponent;
